import SettlementAPI from './settlement.api'

export default SettlementAPI
